<template>
  <div v-if="showIds" class="debug-info">
    <template v-if="!type && data.id">
      <p class="text-body-m-book">
        category_id <span>{{ data.id }}</span>
      </p>
    </template>
    <template v-else-if="type === 'shop-promocodes' || type === 'promocode'">
      <p v-if="data.id" class="text-body-m-book">
        coupon_id <span>{{ data.id }}</span>
      </p>
    </template>
    <template v-else-if="type !== 'promocode'">
      <div v-if="type === 'offer' || type === 'demodel'" class="color">
        <p
          v-if="showModelIdLink && type !== 'demodel'"
          class="text-body-m-book green"
          @click="openModel(data.model_id)"
        >
          M
        </p>
        <p
          v-if="showModelIdLink && type === 'demodel'"
          class="text-body-m-book green"
          @click="openModel(data.model_id)"
        >
          DM
        </p>
        <p v-if="data.quality_score" class="text-body-sx-book yellow">
          qs <span>{{ data.quality_score }}</span>
        </p>
        <p class="text-body-sx-book orange">
          offer_id <span>{{ data.id }}</span>
        </p>
      </div>
      <p v-if="type === 'model' && data.id" class="text-body-m-book">
        model_id <span>{{ data.id }}</span>
      </p>
      <p
        v-else-if="type === 'demodel' && data.model_id"
        class="text-body-m-book"
      >
        model_id <span>{{ data.model_id }}</span>
      </p>
      <p v-if="data.last_modified" class="text-body-m-book">
        update <span>{{ data.last_modified }}</span>
      </p>
      <template v-if="type === 'offer' || type === 'demodel'">
        <p v-if="data.shop_info && data.shop_info.id" class="text-body-m-book">
          shop_id <span>{{ data.shop_info.id }}</span>
        </p>
        <p v-if="data.cost" class="text-body-m-book">
          cost <span>{{ data.cost }}</span>
        </p>
        <p v-if="data.category" class="text-body-m-book">
          category_id <span>{{ data.category.id }}</span>
        </p>
      </template>
    </template>
  </div>
</template>

<script setup lang="ts">
import { useGlobalStore } from '~/stores/global';
import { getModel } from '~/api/pageModel';
import { useTimeCalculation } from '~/composition/useTimeCalculation';

const router = useRouter();
const globalStore = useGlobalStore();
const props = defineProps({
  type: {
    type: String,
    default: '',
  },
  data: {
    type: Object as () => any,
    required: true,
  },
});
const showIds = computed(() => globalStore.debugPanelIds);
const showModelIdLink = computed(
  () => props.data.model_id && globalStore?.seoData?.page?.type !== 'model'
);

const openModel = (id: number) => {
  getModel(String(id), { region_id: globalStore.region.id })
    .then((res) => {
      router?.push(`/${res.slug}/`);
    })
    .catch((e) => console.error(e));
};
useTimeCalculation();
</script>
<style scoped lang="scss" src="./DebugInfoScss.scss" />
